import clsx from 'clsx';

interface SkeletonProps {
  className?: string;
  variant?: 'line' | 'block' | 'circle';
}

export function Skeleton({ className, variant = 'line' }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'animate-pulse bg-panel-border-hi',
        variant === 'line' && 'h-4 rounded-[2px]',
        variant === 'block' && 'h-20 rounded-[3px]',
        variant === 'circle' && 'w-8 h-8 rounded-full',
        className,
      )}
    />
  );
}
